export default "__VITE_ASSET__BTDDBe9i__"